import { render, staticRenderFns } from "./OnboardHeader.vue?vue&type=template&id=6053d695&scoped=true"
import script from "./OnboardHeader.vue?vue&type=script&lang=js"
export * from "./OnboardHeader.vue?vue&type=script&lang=js"
import style0 from "./OnboardHeader.vue?vue&type=style&index=0&id=6053d695&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6053d695",
  null
  
)

export default component.exports